// Simple offline order queue using localStorage.
// Orders created while offline get a client_order_id and are retried.

import { api } from "./api";

const KEY = "teller_offline_orders";

export function listQueue() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function pushQueue(order) {
  const q = listQueue();
  q.push(order);
  localStorage.setItem(KEY, JSON.stringify(q));
}

export function removeFromQueue(clientOrderId) {
  const q = listQueue().filter((o) => o.client_order_id !== clientOrderId);
  localStorage.setItem(KEY, JSON.stringify(q));
}

export async function flushQueue() {
  const q = listQueue();
  if (!q.length) return { synced: 0, total: 0 };
  let synced = 0;
  for (const order of q) {
    try {
      await api.post("/orders", order);
      removeFromQueue(order.client_order_id);
      synced++;
    } catch (e) {
      // stop on first failure, try later
      break;
    }
  }
  return { synced, total: q.length };
}

export function genClientId() {
  return `co_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
